import React from 'react';
import { Modal as SparkModal, SparkModalPortal } from '@spark';

/**
 * Shared confirmation modal for the Playground flows (remove model, shuffle,
 * clear, replace task prompt / model, benchmark save). Standard Spark text
 * modal: title, body content, Cancel + primary action.
 */
const PlaygroundConfirmModal = ({
    open,
    title,
    children,
    primaryLabel = 'Confirm',
    primaryDisableWhenReadOnly = false,
    danger = false,
    feedbackType,
    className,
    onConfirm,
    onCancel,
}) => (
    <SparkModalPortal open={open} onClose={onCancel} size="text">
        <SparkModal
            className={['pg-confirm-modal', 'fs-unmask', className]
                .filter(Boolean)
                .join(' ')}
            title={title}
            feedbackType={feedbackType}
            showSubtitle={false}
            showScrollBar={false}
            fixedHeight={false}
            showFooter
            danger={danger}
            primaryLabel={primaryLabel}
            primaryDisableWhenReadOnly={primaryDisableWhenReadOnly}
            tertiaryLabel="Cancel"
            onPrimaryClick={onConfirm}
            onTertiaryClick={onCancel}
            onCloseClick={onCancel}
        >
            <div className="pg-confirm-modal__body">{children}</div>
        </SparkModal>
    </SparkModalPortal>
);

export default PlaygroundConfirmModal;
